import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth.tsx';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-wayja-teal"></div>
      </div>
    );
  }

  if (!user) {
    // Store the attempted URL to redirect back after login
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  const isAdmin = user.app_metadata?.role === 'admin';

  // For admin routes, check if user has admin role
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/markets" replace />;
  }

  // For non-admin routes, redirect admins to admin dashboard if they're accessing user routes
  if (!requireAdmin && isAdmin && !location.pathname.startsWith('/account')) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
}